module.exports = __webpack_public_path__ + "media/icons/map_icon_blue-f96f57e6.svg";